import React from "react";
import { Modal, Button } from "react-bootstrap";
import "./modal.scss";

const SetAutomationLive = ({
    show,
    hide,
    classchat,
    title,
    text,
    btntext1,
    btntext2,
    onClickSAL
}) => {
    return (
        <section className="as-complete-sec">
            <Modal
                show={show}
                onHide={hide}
                className={classchat}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton> </Modal.Header>
                <Modal.Body>
                    <h3>{title}</h3>
                    <p>{text}</p>
                </Modal.Body>
                <Modal.Footer>
                    <div className="   w-100 text-center">
                        <Button variant="primary" style={{opacity:0.5}} className="m-2"  onClick={hide}>
                            {btntext2}
                        </Button>

                        <Button variant="primary" className="greenBtn " onClick={onClickSAL}>
                            {btntext1}
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </section>
    );
};
export default SetAutomationLive;
